import { Outlet, useLocation } from "react-router-dom";
import { useSubmittedApplicationGuard } from "hooks";
import { useProductContext } from "context/ProductContext";
import { ROUTES } from "routes/constants";

/**
 * Route layout that blocks the in-flow pages (quote, contact, payment, review,
 * confirm-your-identity) once the application has reached a terminal decision
 * page, redirecting to the Something Went Wrong page instead.
 *
 * The contact information page doubles as GIWL's landing page, so it is
 * exempted for GIWL: a fresh landing resets the application via the GIWL quote
 * hydration, and the payment/review routes still block a submitted application
 * from moving deeper.
 */
const SubmittedApplicationGuardLayout = () => {
    const { isGIWL } = useProductContext();
    const { pathname } = useLocation();

    const skip = isGIWL && pathname === ROUTES.APPLICATION.CONTACT;
    const isBlocked = useSubmittedApplicationGuard({ skip });

    return isBlocked ? null : <Outlet />;
};

export default SubmittedApplicationGuardLayout;
